// src/components/layout/Header/NavigationalLayer/CartCounter.jsx

'use client'


import {useCart} from '@/contexts/Cart.context';


export default function CartCounter(){
  const { cartCount } = useCart();
  return <div>{cartCount}</div>
}
